var BundleService = /** @class */ (function () {
    function BundleService(api) {
        var _this = this;
        this.createBundle = function (bundle) {
            var url = '/bundle';
            return _this.API.post(url, bundle);
        };
        this.deleteBundle = function (bundleId) { return _this.API.delete("/bundle/".concat(bundleId)); };
        this.getDeleteConfirmBundle = function (bundleId) {
            return _this.API.get("/bundle/".concat(bundleId, "/delete"));
        };
        this.getRemaining = function (org) {
            var url = "/bundle/".concat(org, "/remaining");
            return _this.API.get(url);
        };
        this.getLimits = function (org) {
            var url = "/bundle/".concat(org, "/limits");
            return _this.API.get(url);
        };
        this.listBundles = function (currency) {
            if (currency === void 0) { currency = ''; }
            var url = "/bundle";
            if (currency && currency !== '') {
                url += "?currency=".concat(currency);
            }
            return _this.API.get(url);
        };
        this.listBundlesForCurrency = function (currency) {
            if (currency === void 0) { currency = ''; }
            var url = "/bundle/currency?codes=".concat(currency);
            return _this.API.get(url);
        };
        this.listBundlesByOrg = function (orgId) {
            var url = "/bundle/".concat(orgId, "/available");
            return _this.API.get(url);
        };
        this.listBundlesAvailableByOrg = function (orgId, DevPlanID) {
            var url = "/bundle/organization?id=".concat(orgId);
            if (DevPlanID && DevPlanID !== '') {
                url += "&plan=".concat(DevPlanID);
            }
            return _this.API.get(url);
        };
        this.getConsumedDeveloperPlan = function (orgId) {
            var url = "/bundle/".concat(orgId, "/consumed");
            return orgId !== 'shared' ? _this.API.get(url) : null;
        };
        this.purchaseBundlesAvailableByOrg = function (orgId, bundleId) {
            var url = "/bundle/purchase?organization=".concat(orgId);
            return _this.API.post(url, [{ bundle: bundleId, quantity: 1 }]);
        };
        this.removeBundlesAvailableByOrg = function (orgId, bundleId) {
            var url = "/bundle/remove?organization=".concat(orgId);
            return _this.API.post(url, [{ bundle: bundleId, quantity: 1 }]);
        };
        this.addBundlesToDevPlanOrg = function (orgId, bundles) {
            var url = "/bundle/purchase?organization=".concat(orgId);
            return _this.API.post(url, bundles);
        };
        this.removeBundlesFromDevPlanOrg = function (orgId, bundles) {
            var url = "/bundle/remove?organization=".concat(orgId);
            return _this.API.post(url, bundles);
        };
        this.listActiveOrgBundles = function (org) {
            var url = "/bundle/".concat(org, "/active");
            return _this.API.get(url);
        };
        this.listActiveOrgBundlesForPlatform = function (appId, platform) {
            var url = "/bundle/".concat(appId, "/").concat(platform, "/active");
            return _this.API.get(url);
        };
        this.createLicense = function (appId, platform) {
            var url = "/license";
            return _this.API.post(url, { app: appId, platform: platform });
        };
        this.hasLicense = function (appId, platform) {
            var url = "/license/".concat(appId, "/").concat(platform, "/licensed");
            return _this.API.get(url);
        };
        this.revokeLicense = function (appId, platform) {
            var url = "/license/".concat(appId, "/").concat(platform, "/revoke");
            return _this.API.delete(url);
        };
        this.getLicense = function (appId, platform) {
            var url = "/license/".concat(appId, "/").concat(platform, "/bundle");
            return _this.API.get(url);
        };
        this.listOrgPaymentHistory = function (org) {
            var url = "/bundle/".concat(org, "/payments");
            return _this.API.get(url);
        };
        this.getBundle = function (bundleId) {
            var url = "/bundle/".concat(bundleId);
            return _this.API.get(url);
        };
        this.updateBundle = function (bundleId, bundle) {
            var url = "/bundle/".concat(bundleId);
            return _this.API.patch(url, bundle);
        };
        this.subscribe = function (bundleId, organisationId, paymentType, invoiceAddress) {
            var url = "/bundle/subscribe";
            return _this.API.post(url, {
                bundle_id: bundleId,
                organisation_id: organisationId,
                payment_type: paymentType,
                invoice_address: invoiceAddress,
            });
        };
        this.getSessionId = function (orgId, bundleID, callbackUrl) {
            var url = "/bundle/".concat(orgId, "/purchase");
            return _this.API.post(url, {
                success_url: callbackUrl,
                fail_url: callbackUrl,
                bundle_id: bundleID,
            });
        };
        this.setInvoicePaid = function (invoiceId) {
            var url = "/bundle/".concat(invoiceId, "/pay");
            return _this.API.get(url);
        };
        this.setPaymentPaid = function (paymentId) {
            var url = "/bundle/payment/".concat(paymentId, "/pay");
            return _this.API.get(url);
        };
        this.listBundlesAvailableByManagedOrg = function (resellerOrgId, managedOrgId, DevPlanID) {
            var url = "/resellers/".concat(resellerOrgId, "/managed/").concat(managedOrgId, "/bundle?plan=").concat(DevPlanID);
            return _this.API.get(url);
        };
        this.listActiveManagedOrgBundles = function (resellerOrgId, managedOrgId) {
            var url = "/resellers/".concat(resellerOrgId, "/managed/").concat(managedOrgId, "/bundle/active");
            return _this.API.get(url);
        };
        this.getManagedOrgConsumedDeveloperPlan = function (resellerOrgId, managedOrgId) {
            var url = "/resellers/".concat(resellerOrgId, "/managed/").concat(managedOrgId, "/bundle/consumed");
            return _this.API.get(url);
        };
        this.API = api;
    }
    BundleService.prototype.configureDefaultOrgDevPlan = function (organizationId) {
        var url = "/bundle/".concat(organizationId, "/devplan/setup");
        return this.API.patch(url);
    };
    return BundleService;
}());
export { BundleService };
